import { useContext, useState } from 'react';
import { Message } from "semantic-ui-react";
import styled from 'styled-components';
import AppContext from '../context/HeaderContext';
import { putAPI } from '../libs/fetchAPI';

const Flex = styled.div`
	margin-top: 10px;
	display: flex;
	justify-content: center;
`;

const CustomMessage = styled(Message)`
	text-align: center;
	width: 70%;
`;

function IntroMessage({ id, message }) {
	const { user, updateUser }             = useContext(AppContext);
	const [ show_message, setShowMessage ] = useState(!(Array.isArray(user.intro_messages) && user.intro_messages.includes(id)));

	const handleDismiss = () => {
		setShowMessage(false);
		const intro_messages = Array.isArray(user.intro_messages) ? [...user.intro_messages, ...[id]] : [id];
		const update         = { ...user, ...{ intro_messages }};

		updateUser(update);

		putAPI(`/users/${user.id}`, {
			intro_messages,
		});
	}

	if(!show_message) {
		return <div></div>;
	}

	return (
		<Flex>
			<CustomMessage
				onDismiss={handleDismiss}
				info
			>
				{message}
			</CustomMessage>
		</Flex>
	)
}

export default IntroMessage;
